import 'react';
import { ButtonCard, BoldHeading } from '@lendi-jam/atoms';
import Grid from '@lendi-ui/grid';
import { Body } from '@lendi-ui/typography';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { bg } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { pt, pb, mb } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3;
var CategoryCardBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  switch (variant) {
    case 'grey':
      return bg('shade.50');
    case 'mint':
      return bg('primary.50');
    default:
      return;
  }
});
var CategoryCardContainer = styled(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  ", "\n  ", "\n"])), pt('xxxl'), pb('xxxl'));
var CategoryCardItem = styled(ButtonCard)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), mb('sm'));

var CategoryCard = function CategoryCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    items = _ref.items,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'white' : _ref$variant;
  var isEven = items.length === 1 || items.length % 2 === 0;
  return /*#__PURE__*/jsx(CategoryCardBackground, {
    variant: variant,
    children: /*#__PURE__*/jsx(CategoryCardContainer, {
      children: /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsxs(Grid.Unit, {
          size: {
            md: 3 / 4,
            lg: 2 / 3,
            xl: 1 / 2
          },
          offset: {
            md: 1 / 8,
            lg: 1 / 6,
            xl: 1 / 4
          },
          children: [title && /*#__PURE__*/jsx(BoldHeading, {
            size: "lg",
            mb: "lg",
            children: title
          }), subtitle && /*#__PURE__*/jsx(Body, {
            mb: "xl",
            children: subtitle
          })]
        }), /*#__PURE__*/jsx(Grid.Unit, {
          size: {
            md: 3 / 4,
            lg: isEven ? 5 / 6 : 1,
            xl: isEven ? 2 / 3 : 1
          },
          offset: {
            md: 1 / 8,
            lg: isEven ? 1 / 12 : 0,
            xl: isEven ? 1 / 6 : 0
          },
          children: /*#__PURE__*/jsx(Grid, {
            gutter: '16px',
            halign: items.length === 1 ? 'center' : 'left',
            children: items.map(function (cardItem, cardIndex) {
              return /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  lg: isEven ? 1 / 2 : 1 / 3
                },
                children: /*#__PURE__*/jsx(CategoryCardItem, {
                  variant: variant === 'white' ? 'grey' : 'white',
                  title: cardItem.title,
                  subtitle: cardItem.subtitle,
                  primaryButton: cardItem.primaryButton,
                  secondaryButton: cardItem.secondaryButton,
                  trackingCategory: "CategoryCard"
                })
              }, cardIndex);
            })
          })
        })]
      })
    })
  });
};

export { CategoryCard as default };
